import CirclePlusInTriangle from "@/components/subject/E808B/CirclePlusInTriangle";
import E808B3AnswerBtn from "@/components/subject/E808B3/E808B3AnswerBtn";
export default {
  name: "E808B3Render",
  components: {
    E808B3AnswerBtn,
    CirclePlusInTriangle
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      ans: {},
      subject: this.$route.params.subject
    };
  },
  methods: {
    onAnswer(qindex, val) {
      this.ans[qindex] = val;
      for (let q of this.data) {
        if (this.ans[q.questionIndex] == null) {
          this.$emit('answer', null);
          return;
        }
      }
      this.$emit('answer', this.ans);
    },
    init() {
      console.log('init', this.data);
      for (let q of this.data) {
        this.ans[q.questionIndex] = null;
      }
    }
  },
  mounted() {
    this.init();
  }
};